import React from 'react';

export default function MapMarker() {
  return (
    <i className="fas fa-map-pin" style={{ fontSize: '20px', color: 'red' }} />
  );
}
